import { render, staticRenderFns } from "./pay-shade.vue?vue&type=template&id=51d8b94a&scoped=true"
import script from "./pay-shade.vue?vue&type=script&lang=js"
export * from "./pay-shade.vue?vue&type=script&lang=js"
import style0 from "./pay-shade.vue?vue&type=style&index=0&id=51d8b94a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d8b94a",
  null
  
)

export default component.exports